import { Component } from '@angular/core';

@Component({
  selector: 'demo-daterangepicker-show-previous-month',
  templateUrl: './show-previous-month.html'
})
export class DemoDateRangePickerShowPreviousMonth {}
